<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-title>{{ app_name }}</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="userLogin" title="Login via Google">Login</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-card text-center color="light">
        <ion-card-header>
          <ion-card-title>
            <h1>Make Forms Great Again</h1>
          </ion-card-title>
          <ion-card-subtitle>
            <h2>Collect data to Google Sheets</h2>
          </ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <img :src="google_login" class="login-google" title="Sign in with Google" v-on:click="userLogin" />
          <!-- <img :src="apple_download" class="download-apple" title="Download on App Store" v-if="platform == 'web'" v-on:click="downloadApple" />
          <img :src="google_download" class="download-google" title="Download on Google Play" v-if="platform == 'web'" v-on:click="downloadAndroid" /> -->
        </ion-card-content>
      </ion-card>
      <ion-grid no-padding no-margin>
        <ion-row>
          <ion-col size="12" size-md="4" size-sm="6">
            <ion-card text-center color="light">
              <ion-card-header>
                <ion-icon ios="ios-clock" md="md-clock" color="primary" class="ion-icon-large"></ion-icon>
                <ion-card-title>Work Faster</ion-card-title>
                <ion-card-subtitle>
                  <h5>Creating and sharing forms has never been easier, intuitive design makes gathering data fast.</h5>
                </ion-card-subtitle>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-md="4" size-sm="6">
            <ion-card text-center color="light">
              <ion-card-header>
                <ion-icon ios="ios-people" md="md-people" color="secondary" class="ion-icon-large"></ion-icon>
                <ion-card-title>Work Together</ion-card-title>
                <ion-card-subtitle>
                  <h5>Easily collaborate with others to gather data in the field together, simply by inviting them by email.</h5>
                </ion-card-subtitle>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-md="4" size-sm="6">
            <ion-card text-center color="light">
              <ion-card-header>
                <ion-icon ios="ios-wifi" md="md-wifi" color="tertiary" class="ion-icon-large"></ion-icon>
                <ion-card-title>Work Offline</ion-card-title>
                <ion-card-subtitle>
                  <h5>Gather data entirely offline, upload your entries once an internet connection becomes available.</h5>
                </ion-card-subtitle>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-md="4" size-sm="6">
            <ion-card text-center color="light">
              <ion-card-header>
                <ion-icon ios="ios-stats" md="md-stats" color="danger" class="ion-icon-large"></ion-icon>
                <ion-card-title>Rich Data</ion-card-title>
                <ion-card-subtitle>
                  <h5>Gather rich data including text, numbers, dates, emails, phone numbers, locations, photos and barcodes.</h5>
                </ion-card-subtitle>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-md="4" size-sm="6">
            <ion-card text-center color="light">
              <ion-card-header>
                <ion-icon ios="ios-phone-portrait" md="md-phone-portrait" color="info" class="ion-icon-large"></ion-icon>
                <ion-card-title>Mobile Apps</ion-card-title>
                <ion-card-subtitle>
                  <h5>Download the iOS and Android app or run the app in the browser, to start collaboratively collecting data today.</h5>
                </ion-card-subtitle>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-md="4" size-sm="6">
            <ion-card text-center color="light">
              <ion-card-header>
                <ion-icon ios="ios-grid" md="md-grid" color="success" class="ion-icon-large"></ion-icon>
                <ion-card-title>Google Sheets</ion-card-title>
                <ion-card-subtitle>
                  <h5>Entries are automatically stored in a Google Spreadsheet, so you can analyze and use the data however you want.</h5>
                </ion-card-subtitle>
              </ion-card-header>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-card color="light">
        <ion-button color="info" expand="block" fill="clear" title="Have questions? Contact us!" v-on:click="contactEmail">
          <h6>Have questions? Contact us!</h6>
        </ion-button>
      </ion-card>
      <footer text-center class="ion-margin-top ion-margin-bottom">
        <p color="medium" class="ion-padding-top">
          <a href="/privacy" title="Privacy Policy">Privacy Policy</a> |
          <a href="/terms" title="Terms of Service">Terms of Service</a>
        </p>
      </footer>
    </ion-content>
  </div>
</template>

<script>
import Helpers from "../mixins/Helpers";
import Plugins from "../mixins/Plugins";
import User from "../models/User";
export default {
  name: "home-page",
  mixins: [Helpers, Plugins],
  data() {
    return {
      platform: "",
      year: new Date().getFullYear(),
      app_name: process.env.VUE_APP_NAME
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser();
    },
    google_login() {
      // return require("../assets/btn_google_signin_light_normal_web.png");
      return require("../assets/btn_google_signin_dark_normal_web.png");
    },
    apple_download() {
      return require("../assets/apple_download_256.png");
    },
    google_download() {
      return require("../assets/google_download.png");
    }
  },
  async created() {
    this.showStatusBar();
    const device = await this.deviceInfo();
    this.platform = device.platform;
  },
  mounted() {
    if (this.user && this.user.email) {
      this.showRootPage("forms");
    }
  },
  methods: {
    async userLogin() {
      try {
        await this.$store.dispatch("userLogin");
        this.showRootPage("forms");
      } catch (error) {
        this.showWarning(error);
      }
    },
    contactEmail() {
      this.openEmail("info@dalezak.com?subject=FormSheets");
    },
    downloadApple() {
      this.showToast("iPhone app coming soon");
    },
    downloadAndroid() {
      this.showToast("Android app coming soon");
    }
  }
};
</script>

<style scoped lang="scss">
h1 {
  font-size: 28px;
}
h2 {
  font-size: 24px;
}
h5 {
  font-weight: 400;
}
ion-icon.ion-icon-large {
  font-size: 64px !important;
}
ion-card-title {
  font-size: 24px;
  font-weight: 500;
}
ion-card-subtitle {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 15px;
}
ion-button {
  line-height: normal;
}
.button-inner {
  flex-flow: row wrap;
}
footer {
  color: var(--ion-color-medium) !important;
}
a {
  color: var(--ion-color-medium) !important;
}
</style>
